<template><div><h1 id="kontenplan" tabindex="-1"><a class="header-anchor" href="#kontenplan"><span>Kontenplan</span></a></h1>
<p>Kontenplan — Definiert Konto/Kostenstellen/Kostenträger-Kombinationen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Der Kontenplan dient der Überprüfung der Dateneingabe und Fakturierung, indem hier sämtliche gültigen Kombinationen von Konti, Kostenstellen und Kostenträger eingegeben werden müssen. Das System überwacht dann automatisch die Buchungen für die Schnittstelle Finanzbuchhaltung, indem es einerseits das Vorhandensein des Kontos, der Kostenstelle bzw. des Kostenträgers überprüft, anderseits die Kombination dieser 3 Ebenen validiert.</p>
<p><strong>Tabelle 47. Erfassungsbeispiele</strong></p>
<table>
<thead>
<tr>
<th>Beispiel</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>*</td>
<td>alle</td>
</tr>
<tr>
<td>66*</td>
<td>alle, die mit 66 beginnen</td>
</tr>
<tr>
<td>&quot;&quot; (leer)</td>
<td>muss leer sein</td>
</tr>
</tbody>
</table>
<p>Pfad: <code v-pre>Buchhaltung → Tabellen → Kontenplan</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Konto</dt>
<dd>Definition für die <a class="link" href="ft.refdata.konti.html" title="Konti">Konti</a></dd>
<dt>Kostenstelle</dt>
<dd>Defintion für die <a class="link" href="ft.refdata.kst.html" title="Kostenstellen">Kostenstellen</a></dd>
<dt>Kostenträger</dt>
<dd>Definition für die <a class="link" href="ft.refdata.ktr.html" title="Kostenträger">Kostenträger</a></dd>
<dt>Mandant</dt>
<dd>Die Definitionen gelten für den hier eingetragenen Mandanten.</dd>
<dt>Beschreibung</dt>
<dd>Beschreibungstext</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.konti.html" title="Konti">Konti</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.kst.html" title="Kostenstellen">Kostenstellen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.ktr.html" title="Kostenträger">Kostenträger</RouteLink></p>
</div></template>


